import { BannerId } from '../../../typings/banners';

export const RESTORE_INTERNAL_BANNERS = 'RESTORE_INTERNAL_BANNERS';
export type RESTORE_INTERNAL_BANNERS = typeof RESTORE_INTERNAL_BANNERS;
export interface RestoreInternalBanners {
    type: RESTORE_INTERNAL_BANNERS;
    bannersIds: BannerId[];
}

export function restoreInternalBannersAction(bannersIds: BannerId[]): RestoreInternalBanners {
    return {
        type: RESTORE_INTERNAL_BANNERS,
        bannersIds
    };
}
